import React, { useEffect } from 'react';
import LoadingState from '../../components/LoadingState';
import { useParams } from 'react-router-dom';
import windowService from '../../services/windowService';

export function TrainingViewer() {
  const { type, id } = useParams<{ type: string; id: string }>();

  useEffect(() => {
    if (type === 'workflow') {
      windowService.redirectTo(`/training-steps/${id}?isWorkflow=true`);
    } else {
      windowService.redirectTo(`/training-steps/${id}`);
    }
  }, [type, id]);

  return <LoadingState />;
}
